import React from 'react';
import { reduxForm, Field } from 'redux-form';

import shippingServiceList from 'helpers/shippingService';
import InputField from './InputField';
import SelectField from './SelectField';
import FormError from './FormError';

const ShippingEstimateForm = ({ handleSubmit, saveStatus, errorMsg }) => (
  <article>
    <form onSubmit={handleSubmit}>
      <Field
        component={InputField}
        type="number"
        min="0"
        step="1"
        title="please enter number only"
        name="zip_code"
        label="Zip Code*"
      />
      <Field
        component={SelectField}
        name="shipping_service"
        label="Shipping service*"
        empty="Choose a shipping service"
        options={shippingServiceList.map((service) => [
          service.value,
          service.name,
        ])}
      />
      <Field
        component={InputField}
        type="number"
        min="0"
        step="1"
        pattern="[0-9]+"
        title="please enter number only"
        name="phones_count"
        label="Phones Count*"
      />
      <Field
        component={InputField}
        type="number"
        min="0"
        step="1"
        pattern="[0-9]+"
        title="please enter number only"
        name="sims_count"
        label="SIMs count*"
      />

      <button className="btn btn-default" disabled={saveStatus === 'PENDING'}>
        Estimate shipping
      </button>

      {errorMsg && (
        <React.Fragment>
          <br />
          <br />
          <FormError error={errorMsg} />
        </React.Fragment>
      )}
    </form>
  </article>
);

const validate = (values) => {
  let errors = {};

  if (!values.zip_code) {
    errors.zip_code = 'Required';
  } else if (values.zip_code.trim().length !== 5) {
    errors.zip_code = 'Please enter a valid zip code';
  }
  if (!values.shipping_service) {
    errors.shipping_service = 'Required';
  }
  if (!values.phones_count) {
    errors.phones_count = 'Required';
  }
  if (!values.sims_count) {
    errors.sims_count = 'Required';
  }

  return errors;
};

export default reduxForm({
  form: 'shippingEstimate',
  validate,
})(ShippingEstimateForm);
